var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeehiiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010202;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.52,292.19H97.95c-3.48,0-6.32-2.85-6.32-6.32v-9.64c0-10.91,8.85-19.76,19.76-19.76h109.54 c10.91,0,19.76,8.85,19.76,19.76v9.64C240.84,289.35,237.99,292.19,234.52,292.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.75,246.04h-79.03c-3.48,0-6.48-2.85-6.48-6.48l0,0c0-16.12,13.12-29.24,29.24-29.24h33.51 c16.12,0,29.24,13.12,29.24,29.24l0,0C212.23,243.2,209.38,246.04,205.75,246.04L205.75,246.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.84,302.63H91.63c-9.8,0-17.86,8.06-17.86,17.86s8.06,17.86,17.86,17.86h52.95 c1.9-10.12,10.75-17.86,21.5-17.86c10.75,0,19.76,7.74,21.65,17.86h52.95c9.8,0,17.86-8.06,17.86-17.86 S250.64,302.63,240.84,302.63L240.84,302.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.36,348.78h-46.31v35.72h34.77c9.8,0,17.86-8.06,17.86-17.86v-11.38 C240.84,351.78,237.99,348.78,234.36,348.78L234.36,348.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.95,348.78c-3.48,0-6.48,2.85-6.48,6.48v11.38c0,9.8,8.06,17.86,17.86,17.86h34.77v-35.72 C144.26,348.78,97.95,348.78,97.95,348.78z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.01,309.9c0,19.44-13.44,31.93-30.98,31.93c-8.38,0-15.02-2.69-19.44-8.06v7.11h-17.23v-85.51h18.02 v30.19c4.58-5.06,10.91-7.59,18.65-7.59C386.41,277.97,400.01,290.46,400.01,309.9z M381.67,309.9 c0-10.75-6.8-17.23-15.81-17.23s-15.81,6.48-15.81,17.23s6.8,17.23,15.81,17.23S381.67,320.65,381.67,309.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.8,321.44l9.64,10.43c-5.69,6.64-14.38,9.96-25.61,9.96c-21.5,0-35.41-13.44-35.41-31.93 s14.07-31.93,33.19-31.93c17.54,0,31.93,11.54,32.09,31.45l-46,8.85c2.69,6.16,8.38,9.17,16.44,9.17 C449.79,327.44,454.54,325.55,458.8,321.44L458.8,321.44z M424.98,308l30.19-5.85c-1.74-6.32-7.11-10.59-14.7-10.59 C431.62,291.56,425.3,297.57,424.98,308L424.98,308z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M531.51,321.44l9.64,10.43c-5.69,6.64-14.38,9.96-25.61,9.96c-21.5,0-35.41-13.44-35.41-31.93 s14.07-31.93,33.19-31.93c17.54,0,31.93,11.54,32.09,31.45l-45.84,8.85c2.69,6.16,8.38,9.17,16.44,9.17 C522.5,327.44,527.24,325.55,531.51,321.44L531.51,321.44z M497.69,308l30.19-5.85c-1.74-6.32-7.11-10.59-14.7-10.59 C504.33,291.56,498.16,297.57,497.69,308z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M620.97,305.47v35.56h-18.02v-32.88c0-9.96-4.58-14.7-12.64-14.7c-8.69,0-14.86,5.37-14.86,16.75v30.66 h-18.02v-85.51h18.02v30.03c4.9-4.9,11.85-7.43,19.76-7.43C609.91,277.97,620.97,286.5,620.97,305.47L620.97,305.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M635.04,260.11c0-5.69,4.58-10.12,11.22-10.12c6.64,0,11.22,4.11,11.22,9.64c0,6.01-4.58,10.43-11.22,10.43 C639.63,270.07,635.04,265.8,635.04,260.11z M637.26,278.92h18.02v62.12h-18.02C637.26,340.88,637.26,278.92,637.26,278.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M669.82,260.11c0-5.69,4.58-10.12,11.22-10.12s11.22,4.11,11.22,9.64c0,6.01-4.58,10.43-11.22,10.43 S669.82,265.8,669.82,260.11z M672.03,278.92h18.02v62.12h-18.02C672.03,340.88,672.03,278.92,672.03,278.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M768.29,278.92l-26.24,62.12H723.4l-26.08-62.12h18.65l17.23,42.2l17.7-42.2 C751.06,278.92,768.29,278.92,768.29,278.92z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeehiiv);
export default __webpack_public_path__ + "static/media/Beehiiv.06ee1f64fe8a180ae2925958c7f50d99.svg";
export { ForwardRef as ReactComponent };